import React from "react";
import styles from "./details.module.css";
import { Divider, Typography } from "antd";
import SVGIcon from "../../../../../../constants/SVGIcon";
import CustomButton from "../../../../../../common/custom-button/custom-button";
import { formatDate } from "../../../../../../utils/format-date/format-date";

const Details = ({data}) => {

  const toughtSubject = data?.subjects_taught?.map((e => e?.subject_name));

  const handleDownload = (imageUrl) => {
    const fileName = imageUrl.substring(imageUrl.lastIndexOf("/") + 1);

    const link = document.createElement("a");
    link.href = imageUrl; // Use the pre-signed URL (S3 URL)
    link.download = fileName; // Set the filename based on the URL
    link.setAttribute("target", "_self");
    link.setAttribute("rel", "noopener noreferrer");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up by removing the link
  };
  return(
  <>
    <div className={styles.details}>
      <Divider
        orientation="left"
        orientationMargin="0"
        style={{ margin: "0px 0" }}
      >
        <Typography className={styles.dividerTitle}>
          Personal Information
        </Typography>
      </Divider>
      <div className={styles.infoContainer}>
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoLabel}>First Name:</Typography>
            <Typography className={styles.infoLabel}>Last Name:</Typography>
            <Typography className={styles.infoLabel}>Date of Birth:</Typography>
            <Typography className={styles.infoLabel}>Title:</Typography>
            <Typography className={styles.infoLabel}>Qualifications:</Typography>
          </div>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoValue}>{data?.first_name ?? "-"}</Typography>
            <Typography className={styles.infoValue}>{data?.last_name ?? "-"}</Typography>
            <Typography className={styles.infoValue}>
              {data?.date_of_birth ? formatDate(data?.date_of_birth) : "-"}
            </Typography>
            <Typography className={styles.infoValue}>{data?.title ?? "-"}</Typography>
            <Typography className={styles.infoValue}>{data?.highest_degree ?? "-"}</Typography>
          </div>
        </div>
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoLabel}>Middle Name:</Typography>
            <Typography className={styles.infoLabel}>Gender:</Typography>
            <Typography className={styles.infoLabel}>
              Nation ID Number:
            </Typography>
            <Typography className={styles.infoLabel}>Full Address:</Typography>
          </div>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoValue}>{data?.middle_name ? data?.middle_name : "-"}</Typography>
            <Typography className={styles.infoValue}>{data?.gender ? data?.gender : "-"}</Typography>
            <Typography className={styles.infoValue}>{data?.national_id ? data?.national_id : "-"}</Typography>
            <Typography className={styles.infoValue}>{data?.full_address ? data?.full_address : "-"}</Typography>
          </div>
        </div>
      </div>

      <Divider
        orientation="left"
        orientationMargin="0"
        style={{ margin: "5px 0" }}
      >
        <Typography className={styles.dividerTitle}>
          Account Information
        </Typography>
      </Divider>
      <div className={styles.infoContainer}>
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoLabel}>Phone Number:</Typography>
          </div>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoValue}>
            {data?.phone_number ? data?.phone_number : "-"}
            </Typography>
          </div>
        </div>
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoLabel}>Email:</Typography>
          </div>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoValue}>{data?.email ? data?.email : "-"}</Typography>
          </div>
        </div>
      </div>

      <Divider
        orientation="left"
        orientationMargin="0"
        style={{ margin: "5px 0" }}
      >
        <Typography className={styles.dividerTitle}>
          School Information
        </Typography>
      </Divider>
      <div className={styles.infoContainer}>
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoLabel} style={{ whiteSpace: "nowrap" }}>
              Subjects Taught:
            </Typography>
          </div>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoValue}>
              {data?.subjects_taught?.length > 0 ? data?.subjects_taught?.map(item => item?.subject_name)?.join(", ") : "-"}
            </Typography>
          </div>
        </div>
        <div className={styles.infoRow}>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoLabel}>Designation:</Typography>
          </div>
          <div className={styles.infoColumn}>
            <Typography className={styles.infoValue}>{data?.designation ? data?.designation : "-"}</Typography>
          </div>
        </div>
      </div>
    </div>
  </>
);
}

export default Details;
